'use strict';

/* Directives */


app.directive('file', function () {
    return {
        scope: {
            file: '='
        },
        link: function (scope, el, attrs) {
            el.bind('change', function (event) {
                var file = event.target.files[0];
                scope.file = file ? file : undefined;
                scope.$apply();
            });
        }
    };
});


app.directive('disableLink', function() {
    return function(scope, element, attrs) {
        $(element).click(function(event) {
            event.preventDefault();
        });
    }
});


app.directive('imageFallback', ['$q', function ($q) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            attrs.$observe('ngSrc', function (ngSrc) {
                var deferred = $q.defer();
                var image = new Image();
                image.onerror = function () {
                    deferred.resolve(false);
                    element.attr('src', attrs.imageFallback);
                };
                image.onload = function () {
                    deferred.resolve(true);
                };
                image.src = ngSrc;
                return deferred.promise;
            });
        }
    };
}]);


app.directive('restrictInput', [function(){
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var ele = element[0];
            var regex = RegExp(attrs.restrictInput);
            var value = ele.value;

            ele.addEventListener('keyup',function(e){
                if (regex.test(ele.value)){
                    value = ele.value;
                }else{
                    ele.value = value;
                }
            });
        }
    };
}]);


app.directive('fileChange', ['$parse', function($parse) {
    return {
        require: 'ngModel',
        restrict: 'A',
        link: function ($scope, element, attrs, ngModel) {

            var attrHandler = $parse(attrs['fileChange']);
            var handler = function (e) {

                $scope.$apply(function () {
                    attrHandler($scope, { $event: e, files: e.target.files });
                });
            };

            element[0].addEventListener('change', handler, false);
        }
    };
}]);